import type { ErrorEvent } from '@sentry/core'

const searchOnFrames = (event: ErrorEvent, adsList: string[]): boolean => {
  const exception = event?.exception?.values?.[0] ?? {
    stacktrace: {
      frames: [],
    },
  }
  const { frames = [] } = exception?.stacktrace ?? { frames: [] }

  return (
    frames.filter((frame) => {
      const { filename } = frame
      return adsList.some((match) => filename?.includes(match) ?? false)
    }).length > 0
  )
}

export default searchOnFrames
